import { createRouter, createWebHashHistory, createWebHistory, RouteRecordRaw } from 'vue-router';
import store from '@/store';
import newsRouter from '@/router/modules/news';
import productionRouter from '@/router/modules/production';
import technologyRouter from '@/router/modules/technology';
import joinRouter from '@/router/modules/join';
import aboutRouter from '@/router/modules/about';
import { agreementRouter, agreementViewRouter } from '@/router/modules/agreement';
import NProgress from 'nprogress';

// 通用框架
const Layout = () => import('@/layout/index.vue');

// 固定路由
const routes:Array<RouteRecordRaw> = [
    {
        path: '/',
        component: Layout,
        redirect: '/index',
        name: 'home',
        children: [
            {
                path: 'index',
                name: 'home-index',
                component: () => import('@/pages/index.vue'),
                meta: {
                    title: () => import.meta.env.VITE_APP_TITLE as string
                }
            }
        ]
    },
    newsRouter,
    productionRouter,
    technologyRouter,
    joinRouter,
    aboutRouter,
    agreementRouter,
    agreementViewRouter,
    {
        path: '/reload',
        name: 'reload',
        component: () => import('@/pages/reload.vue')
    },
    {
        path: '/:pathMatch(.*)*',
        name: '404',
        component: () => import('@/pages/404.vue'),
        meta: { title: '找不到页面' }
    }
];

// 创建路由器
const router = createRouter({
    history: import.meta.env.VITE_HISTORY_MODE === 'html5' ? createWebHistory(import.meta.env.VITE_PUBLIC_PATH as string || '') : createWebHashHistory(),
    routes: routes
});

router.isReady().then(async() =>
{
    // const { registerSW } = await import('virtual:pwa-register');
    // registerSW({ immediate: true });
});

// 添加路由守卫，在任何导航前执行
router.beforeEach(async(to, from, next) =>
{
    NProgress.start();
    console.log('beforeEach', from, to);

    // from: 当前导航正要离开的路由
    // to: 即将要进入的目标路由对象

    // 方案一：每次跳转的时候，给路由全局添加一个时间戳参数
    // 方案二：记录历史路由记录，每次进入后前判断
    if (typeof to.query.__t !== 'undefined')
    {
        next();
    }
    else
    {
        to.query.__t = new Date().getTime().toString();
        next(to);
    }

    // return true;

});

// 添加路由钩子，每次导航后执行
router.afterEach((to, from) =>
{
    // console.log('afterEach', to, from);

    // 监听路由变动，根据to和from的时间戳判断是前进还是后退
    if (parseInt(to.query.__t as string) < parseInt(from.query.__t as string))
    {
        store.commit('updateRouterActionType', 'back');
    }
    else
    {
        store.commit('updateRouterActionType', 'forward');
        window.scrollTo(0, 0); // 前进时，则滚动到顶部
    }

    console.log('actionType', store.state.routerActionType);

    NProgress.done();
    // 设置当前选中的路由
    store.commit('setSelRouteName', to.name);
    // 设置页面 title
    to.meta.title && store.commit('setTitle', typeof to.meta.title === 'function' ? to.meta.title() : `${import.meta.env.VITE_APP_TITLE} - ${to.meta.title}`);
});

export default router;
